import { useAppDispatch } from "../../../../../../hooks/hooks";
import { useCallback } from "react";
import { RefundRequestDTO } from "../../../../../../types/orders";
import {postCollectAsync, postRefundAsync} from "../../../../../../store/orderSlice";

export function useCreateRefund() {
  const dispatch = useAppDispatch();

    return useCallback(
        (orderIdx: number, refundRequestDTO: RefundRequestDTO, onSuccess: () => void) => {

            const postAsync = (!refundRequestDTO.refundPrice || refundRequestDTO.refundPrice === 0)
                ? postCollectAsync
                : postRefundAsync;

            return dispatch(postAsync({ orderIdx, refundRequestDTO }))
                .unwrap()
                .then(() => onSuccess());
                // .then(() => {});
        },

        //eslint-disable-next-line
        [dispatch, postCollectAsync, postRefundAsync]
    );
}
